'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoIcon = exports.ErrorIcon = exports.WarningIcon = exports.QuestionIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cleanProps = require('../../common/cleanProps');

var _cleanProps2 = _interopRequireDefault(_cleanProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propsToRemove = {
  size: true
};

var QuestionIcon = function QuestionIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, (0, _cleanProps2.default)(props, propsToRemove), {
      width: props.size,
      height: props.size,
      viewBox: '0 0 24 24'
    }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
  );
};

var WarningIcon = function WarningIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, (0, _cleanProps2.default)(props, propsToRemove), {
      width: props.size,
      height: props.size,
      viewBox: '0 0 24 24'
    }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};

var ErrorIcon = function ErrorIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, (0, _cleanProps2.default)(props, propsToRemove), {
      width: props.size,
      height: props.size,
      viewBox: '0 0 24 24'
    }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
  );
};

var InfoIcon = function InfoIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, (0, _cleanProps2.default)(props, propsToRemove), {
      width: props.size,
      height: props.size,
      viewBox: '0 0 24 24'
    }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
  );
};

exports.QuestionIcon = QuestionIcon;
exports.WarningIcon = WarningIcon;
exports.ErrorIcon = ErrorIcon;
exports.InfoIcon = InfoIcon;